

import { bootstrapApplication } from '@angular/platform-browser';
import { provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { authInterceptor } from './src/interceptors/auth.interceptor';
import { primengEsTranslation } from './src/core/primeng-es.translation';

// Preset con color primary personalizado: cambia '#2563eb' por el hex de tu marca
const PentoAura = definePreset(Aura, {
  semantic: {
    primary: {
      500: '#2563eb',
      600: '#1d4ed8',
      700: '#1e40af'
    }
  },
  components: {
    select: {
      option: {
        focusBackground: '#e2e8f0',
        focusColor: '#2563eb',
        selectedBackground: '#e2e8f0',
        selectedColor: '#2563eb',
        selectedFocusBackground: 'oklch(93.2% 0.032 255.585)',
        color: "#2563eb",
        selectedFocusColor: "#2563eb",
      }
    }
  }
});
import { routes } from './src/app.routes';

import { AppComponent } from './src/app.component';

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimations(),
    providePrimeNG({
      translation: primengEsTranslation,
      theme: {
        preset: PentoAura,
        options: {
          darkModeSelector: ''
        }
      }
    }),
    provideToastr({
      positionClass: 'toast-bottom-right',
      closeButton: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      timeOut: 4000,
      extendedTimeOut: 1500,
      easeTime: 200,
      newestOnTop: true,
      maxOpened: 3,
      autoDismiss: true,
      tapToDismiss: true,
      preventDuplicates: true
    })
  ],
}).catch(err => console.error(err));
